{"initialConfig":{"showBindings":true,"showHeaders":true},"groups":[{"name":"Only Vehicles"}]}